const mutations = {
    SET_LISTSMALL: (state, payload) => {
        state.listSmall = payload;
    },
    SET_PAYTIP: (state, payload) => {
        state.payTip = payload;
    },
    SET_CHOOSEDATE: (state, payload) => {
        state.chooseDate = payload;
    }
};
export default mutations;
